import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeClass as _normalizeClass, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = { class: "o-grid__cell o-grid__cell--12 o-grid__cell--3-480 u-text-align-right--480 tariff-left-col" }
const _hoisted_2 = ["onClick"]
const _hoisted_3 = { class: "o-grid__cell o-grid__cell--12 o-grid__cell--9-480 o-grid__cell--8-768 o-grid__cell--7-1024 o-grid__cell--6-1200 tariff-right-col" }
const _hoisted_4 = { class: "o-grid o-grid--no-y-gutter add-on tarif-options-module" }
const _hoisted_5 = {
  key: 0,
  class: "u-text-align-center vertikal-zentrieren u-color-secondary"
}
const _hoisted_6 = {
  key: 1,
  class: "u-text-align-center vertikal-zentrieren"
}
const _hoisted_7 = { class: "" }
const _hoisted_8 = {
  key: 2,
  class: "u-text-align-center vertikal-zentrieren"
}
const _hoisted_9 = { class: "" }
const _hoisted_10 = {
  key: 3,
  class: "u-text-align-center vertikal-zentrieren"
}
const _hoisted_11 = {
  class: "o-grid__cell o-grid__cell--12 o-grid__cell--12-480 o-grid__cell--11-768 o-grid__cell--10-1024 o-grid__cell--9-1200",
  style: {"border-bottom":"1px solid #000000 !important"}
}
const _hoisted_12 = {
  key: 0,
  class: "gev19__contexthelp-text gev19__contexthelp-inlinetabletest"
}
const _hoisted_13 = ["onClick"]
const _hoisted_14 = ["innerHTML"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_icon_sprite = _resolveComponent("icon-sprite")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.sichtbareZeilen, (zeile, index) => {
      return (_openBlock(), _createElementBlock("div", {
        key: zeile.index
      }, [
        _createElementVNode("div", {
          class: _normalizeClass(["o-grid table-row gev19__contexthelp", {
        'first-row': index === 0,
        'last-row': index === _ctx.sichtbareZeilen.length - 1,
      }])
        }, [
          _createElementVNode("div", _hoisted_1, [
            _createTextVNode(_toDisplayString(zeile.leistungstext) + " ", 1),
            (zeile.infoText.length)
              ? (_openBlock(), _createElementBlock("span", {
                  key: 0,
                  class: "gev19__contexthelp-open",
                  title: "Hilfe anzeigen",
                  onClick: ($event: any) => (_ctx.zeigeInfo(zeile))
                }, null, 8, _hoisted_2))
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(zeile.leistungen, (leistung, index) => {
                return (_openBlock(), _createElementBlock("div", {
                  key: index,
                  class: _normalizeClass(["add-on__option", _ctx.getCssForCol(index + 1, _ctx.aktiveLinie)])
                }, [
                  (leistung === 'Ja')
                    ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                        _createVNode(_component_icon_sprite, { "icon-name": "icon-check-mark" })
                      ]))
                    : (leistung === 'Nein')
                      ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                          _createElementVNode("div", _hoisted_7, [
                            _createVNode(_component_icon_sprite, { "icon-name": "icon-minus" })
                          ])
                        ]))
                      : (zeile.berechnung === true)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                            _createElementVNode("div", _hoisted_9, _toDisplayString(_ctx.getBerechneLeistung(leistung)), 1)
                          ]))
                        : (_openBlock(), _createElementBlock("div", _hoisted_10, [
                            _createElementVNode("div", {
                              class: _normalizeClass(zeile.leistungsstil)
                            }, _toDisplayString(leistung), 3)
                          ]))
                ], 2))
              }), 128))
            ])
          ]),
          _createElementVNode("div", _hoisted_11, [
            (zeile.show)
              ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                  (zeile.show)
                    ? (_openBlock(), _createElementBlock("div", {
                        key: 0,
                        onClick: ($event: any) => (_ctx.zeigeInfo(zeile)),
                        class: "gev19__contexthelp-close",
                        title: "Hilfe schließen"
                      }, null, 8, _hoisted_13))
                    : _createCommentVNode("", true),
                  _createElementVNode("div", {
                    innerHTML: zeile.infoText
                  }, null, 8, _hoisted_14)
                ]))
              : _createCommentVNode("", true)
          ])
        ], 2),
        _cache[0] || (_cache[0] = _createStaticVNode("<div class=\"o-grid gimmick\"><div class=\"o-grid__cell o-grid__cell--12 o-grid__cell--3-480 gimmick-left-col\"></div><div class=\"o-grid__cell o-grid__cell--12 o-grid__cell--9-480 o-grid__cell--8-768 o-grid__cell--7-1024 o-grid__cell--6-1200 gimmick-right-col\"><div class=\"o-grid o-grid--no-y-gutter add-on\"><div class=\"tariff-column-1 add-on__option\"></div><div class=\"tariff-column-2 add-on__option\"></div><div class=\"tariff-column-3 add-on__option\"></div></div></div></div>", 1))
      ]))
    }), 128)),
    _cache[1] || (_cache[1] = _createStaticVNode("<div class=\"o-grid gimmick gimmick__bottom\"><div class=\"o-grid__cell o-grid__cell--12 o-grid__cell--3-480 gimmick-left-col\"></div><div class=\"o-grid__cell o-grid__cell--12 o-grid__cell--9-480 o-grid__cell--8-768 o-grid__cell--7-1024 o-grid__cell--6-1200 gimmick-right-col\"><div class=\"o-grid o-grid--no-y-gutter add-on\"><div class=\"tariff-column-1 add-on__option\"></div><div class=\"tariff-column-2 add-on__option\"></div><div class=\"tariff-column-3 add-on__option\"></div></div></div></div>", 1))
  ], 64))
}